import { render, staticRenderFns } from "./Model21.vue?vue&type=template&id=6028e88d&scoped=true"
import script from "./Model21.vue?vue&type=script&lang=js"
export * from "./Model21.vue?vue&type=script&lang=js"
import style0 from "./Model21.vue?vue&type=style&index=0&id=6028e88d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028e88d",
  null
  
)

export default component.exports